import React from 'react';
import DepositPage from './DepositPage';

const Payment = () => <DepositPage />;

export default Payment;
